import {
  Component,
  computed,
  input,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NavService } from '@app/core/services/nav.service';
import { INavList, INavItem } from '../../interfaces/navigation.interface';
import { NgTemplateOutlet } from '@angular/common';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Ag1BadgeSolidComponent } from '../../../../core/components/ag1-badge-solid/ag1-badge-solid.component';

@Component({
  selector: 'app-navigation-item',
  templateUrl: './navigation-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgTemplateOutlet,
    RouterLinkActive,
    RouterLink,
    AngularSvgIconModule,
    Ag1BadgeSolidComponent,
  ],
})
export class NavigationItemComponent {
  navService = inject(NavService);

  readonly navItem = input<INavItem>();
  readonly navList = input<INavList>();
  readonly isNested = input<boolean>(false);

  readonly NAV_LIST_TYPE = 'navList';
  readonly NESTED_NAV_ITEM_TYPE = 'nestedNavItem';
  readonly NAV_ITEM_TYPE = 'navItem';

  // Computed signal to determine which template to use
  readonly itemType = computed(() => {
    if (this.navList()) {
      return this.NAV_LIST_TYPE;
    }

    if (this.navItem() && this.isNested()) {
      return this.NESTED_NAV_ITEM_TYPE;
    }

    if (this.navItem()) {
      return this.NAV_ITEM_TYPE;
    }

    return null;
  });

  readonly isListExpanded = computed(() => {
    return (
      this.itemType() === this.NAV_LIST_TYPE &&
      this.navService.isSelectedList(this.navList()?.label)
    );
  });

  constructor() {}

  onNavItemSelect(item: INavItem): void {
    this.navService.selectItem(item);
    this.navService.selectList(null);
    this.navService.closeMobileMenu();
  }

  onNavListSelect(list: INavList): void {
    this.navService.selectList(list);
  }

  onNestedNavItemSelect(item: INavItem): void {
    this.navService.selectItem(item);
    this.navService.closeMobileMenu();
  }
}
